import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { buttonClasses } from "@mui/material/Button";

export const StyledLinkApplicationBackButtonBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "flex-start",
  alignSelf: "stretch",
}));

export const StyledBackButtonBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "flex-start",
  alignSelf: "stretch",
}));

export const StyledLinkApplicationSubTextBox = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  "& .MuiLink-root": {
    marginLeft: theme.spacing(0.5),
  },
  "& .MuiSvgIcon-root": {
    fill: "#1E824C",
    marginRight: theme.spacing(1),
    width: "20px",
    height: "20px",
  },
  "& .MuiTypography-root": {
    "& .MuiLink-root": {
      marginRight: theme.spacing(0.5),
      display: "inline-flex",
    },
  },
}));

export const StyledSubmitButtonBox = styled(Box)(({ theme }) => ({
  justifyContent: "center",
  display: "flex",
  [`& .${buttonClasses.root}`]: {
    minWidth: "50%",
    margin: "0px",
  },
  [theme.breakpoints.down("sm")]: {
    [`& .${buttonClasses.root}`]: {
      minWidth: "100%",
    },
  },
}));

export const StyledLinkApplicationFieldWrapperBox = styled(Box)(
  ({ theme }) => ({
    maxWidth: "30%",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
    },
  })
);

export const StyledFieldNameWrapperBox = styled(Box)(({ theme }) => ({
  maxWidth: "60%",
  [theme.breakpoints.down("sm")]: {
    maxWidth: "100%",
  },
}));

export const StyledAlertContentBox = styled(Box)(({ theme }) => ({
  "& .MuiLink-root": {
    display: "inline",
    margin: theme.spacing(0, 0.5),
  },
}));
export const StyledLinkApplicationSubmitButtonBox = styled(Box)(
  ({ theme }) => ({
    justifyContent: "center",
    display: "flex",
    [`& .${buttonClasses.root}`]: {
      minWidth: "50%",
      margin: "0px",
    },
    [theme.breakpoints.down("sm")]: {
      [`& .${buttonClasses.root}`]: {
        minWidth: "100%",
      },
    },
  })
);
